import React from 'react';
import wall from "../images/wall.jpg"
import roof from '../images/roof.jpg'
import basement from '../images/basement.jpg'

// Array of services with head, disc, and image
const services = [
    {
        head: 'Roof Water proofing',
        disc: 'Protect your roof from leaks and water damage with our advanced waterproofing techniques, ensuring long-lasting protection for your home or business.',
        image: roof
    },
    {
        head: 'Basement Water proofing',
        disc: 'Transform your damp, leaky basement into a dry, usable space with our expert basement waterproofing solutions, including interior and exterior methods.',
        image: basement
    },
    {
        head: 'Wall  Water proofing',
        disc: 'Keep your walls dry and protected from moisture with our comprehensive wall waterproofing services, preventing costly water damage and mold growth.',
        image: wall
    }
];

const Service = () => {
    return (
        <div className='service' id='service1'>
            <h1 className='service_head'>
                Our Waterproofing Expertise
            </h1>
            <div className='service_element'>
                {services.map((service, index) => (
                    <div key={index} className='service_item'>
                        <h2 className='service_item_head'>{service.head}</h2>
                        <p className='service_item_disc'>{service.disc}</p>
                        <img className='service_item_image' src={service.image} alt={service.head} />
                    </div>

                ))}</div>
        </div>
    );
}

export default Service;
